import type { PresetMaterial } from '../../gql';

import { randBoolean, randNumber } from '@ngneat/falso';

import { mockMaterial } from './mockMaterial';
import { mockMaterialOnTheFly } from './mockMaterialOnTheFly';
import { mockPresetComponentType } from './mockPresetComponentType';
import { mockUnitOfMeasurement } from './mockUnitOfMeasurement';

const mockPresetMaterial = (
    overwrite?: Partial<PresetMaterial>
): PresetMaterial => {
    const hasMaterialOnTheFly = randBoolean();
    const material = hasMaterialOnTheFly ? null : mockMaterial();

    // Mirrors material.materialComposition (e.g. zipper teeth/tape/slider) so every
    // composition row has a matching colour/DTM entry to read and write.
    const componentTypes = material
        ? material.materialComposition.map((compositionComponent) =>
              mockPresetComponentType({ type: compositionComponent.type })
          )
        : [mockPresetComponentType()];

    return {
        material,
        materialOnTheFly: hasMaterialOnTheFly ? mockMaterialOnTheFly() : null,
        avgConsumption: randBoolean() ? randNumber() : null,
        unitOfMeasurement: randBoolean() ? mockUnitOfMeasurement() : null,
        size: null,
        componentTypes,
        ...overwrite,
    };
};

export { mockPresetMaterial };
